<template>
  <section>
    <div style="width: 98%; margin: auto">
      <ProjectList @proSelected="proChange"></ProjectList>
    </div>
    <el-row>
      <el-col :span="12">
        <div class="tBox">
          <div class="title"><i></i>塔吊数据统计</div>
          <div class="contentBox">
            <div class="c-title">
              <el-select v-model="towerVal" placeholder="请选择" style="width: 100px;height: 10px;" @change="towerChange">
                  <el-option v-for="(item,index) in towerData" :label="item.name" :value="index" :key="index"></el-option>
              </el-select>
            </div>
            <el-row>
              <el-col :span="12">
                <div class="c-mes2">{{towerObj.hangTimes}}</div>
                <div class="c-mes1">今日吊次</div>
              </el-col>
              <el-col :span="12">
                <div class="c-mes2">{{towerObj.alertTimes}}</div>
                <div class="c-mes1">超载报警</div>
              </el-col>
            </el-row>
            <table cellspacing="1">
              <tr class="trbg">
                <td>风力</td>
                <td>高度</td>
                <td>幅度</td>
                <td>载重</td>
                <td>力距</td>
                <td>转动角度</td>
                <td>倾斜角度</td>
              </tr>
              <tr class="tdbg">
                <td>{{towerObj.windForces}}</td>
                <td>{{towerObj.height}}</td>
                <td>{{towerObj.range}}</td>
                <td>{{towerObj.weight}}</td>
                <td>{{towerObj.momentForce}}</td>
                <td>{{towerObj.turnAngle}}</td>
                <td>{{towerObj.leanAngle}}</td>
              </tr>
            </table>
            <div id="t1" style="width: 100%; height: 265px;margin-top: 10px;"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="tBox" style="overflow-y: scroll">
          <div class="title"><i></i>电梯管理</div>
          <div class="contentBox" v-for="(item,index) in elevatorData">
            <div class="c-title">{{item.name}}</div>
            <table cellspacing="1">
              <tr class="trbg">
                <td>超载报警</td>
                <td>外门监测</td>
                <td>内门监测</td>
                <td>重量监测</td>
                <td>速度监测</td>
                <td>倾斜度</td>
              </tr>
              <tr class="tdbg">
                <td>{{item.alertTimes}}</td>
                <td>{{item.outDoor.val?'开':'关'}}</td>
                <td>{{item.inDoor.val?'开':'关'}}</td>
                <td>{{item.wCheck}}</td>
                <td>{{item.sCheck}}</td>
                <td>{{item.lean}}</td>
              </tr>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="tBox" style="width: 98%; overflow-y: scroll">
          <div class="title"><i></i>智能安防围挡</div>
          <div class="contentBox" v-for="(item,index) in railData">
            <div class="c-title">{{item.name}}</div>
            <el-row>
              <el-col :span="2.4" v-for="(n,index) in item.data" :key="index">
                <ul>
                  <li class="trbg">{{n.name}}</li>
                  <li class="tdbg"><span v-if="n.state" style="color: green;">正常</span><span v-if="!n.state" style="color: red;">拆除</span></li>
                </ul>
              </el-col>

            </el-row>

          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>
<script>

  import {tower, elevator, rail,proSearch} from '../../api/api'
  import echarts from 'echarts'
  import ProjectList from "../command/ProjectList";

  export default {
    components: {ProjectList},
    data () {
      return {
        railData:{},
        elevatorData:{},
        towerData:{},
        towerVal:0,
        towerObj:{},
        proId: null,
        proList: [],
      }
    },
    methods: {
      proChange: function (proId) {
          this.proId = proId;
          //初始化数据
          tower({projectId:this.proId}, this.GLOBAL.header).then(result => {
            if(result.data.res == 'SUCCESS'){
              this.towerData = result.data.data;
              this.towerObj=this.towerData[0];
            }

          })
          elevator({projectId:this.proId}, this.GLOBAL.header).then(result => {
            if(result.data.res == 'SUCCESS'){
              this.elevatorData = result.data.data;
            }

          })
          rail({projectId:this.proId}, this.GLOBAL.header).then(result => {
            if(result.data.res == 'SUCCESS'){
              this.railData = result.data.data;
            }
          })
      },

      towerChange:function(val){
        this.towerObj = this.towerData[val];
        this.drawT1Chart();
      },
      drawT1Chart () {
        this.safechart = echarts.init(document.getElementById('t1'))
        this.safechart.setOption({
          color: ['#c8ffd6'],
          title: {text: '吊次统计'},
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: this.towerObj.timeAxis
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data:this.towerObj.momentForceList,
            type: 'line',
            areaStyle: {normal: {}}
          }]
        })
      },
    },
    mounted () {

    },
    updated () {
      this.drawT1Chart();
    }
  }
</script>
<style>
  .contentBox ul{ width: 72px; height: 62px;}
  .contentBox li{
    list-style: none;
    height: 30px;
    line-height: 30px;
    width: 71px;
    border: 1px solid #b8b8b8;
    margin-top: -1px;
    text-align: center;
  }

  .tBox {
    position: relative;
    border: 1px solid #c0c7d1;
    width: 96%;
    margin: 0 auto;
    margin-top: 20px;
    height: 500px;
    box-shadow: darkgrey 0px 0px 2px 0px;
  }

  .tBox .title {
    text-indent: 1em;

  }

  .contentBox {
    width: 90%;
    margin: auto;
    margin-top: 10px;
  }

  .c-title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .c-mes1 {
    text-align: center;
    font-size: 12px;
    color: #8c939d;
  }

  .c-mes2 {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    height: 20px;
    line-height: 20px;
  }

  .tBox table {
    width: 100%;
    background: #b8b8b8;
    overflow-y: scroll;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .tBox table tr {
    height: 30px;
    text-align: center;
  }

  .trbg {
    background: #DDE5D4
  }

  .tdbg td {
    background: #f8f8f8
  }

  .c-z {
    color: red;
  }


</style>



// WEBPACK FOOTER //
// src/components/device/data.vue